import { useQuery } from "@apollo/client/react";
import { GetUserPermissions } from "./permissions.gql";

export default function useGetPermissions() {
  const { data, loading, error } = useQuery(GetUserPermissions);

  return { data, error, loading, permissions: data?.permissions };
}
